<template>
	<Box :tag="tag" :class="classes" :style="styles" v-on="$listeners" v-bind="$attrs">
		<slot></slot>
	</Box>
</template>
<script>
import boxWhitespace from '../css/boxWhitespace.module.css'
import typography from '../css/typography.module.css'
import textStyle from '../css/text.module.css'
import Box from '@/shared/layout/box/layout-box.vue'

export default {
	components: {
		Box
	},
	props: {
		align: {
			type: String,
			default: 'left'
		},
		fontSize: {
			type: [Number, String],
			default: 2
		},
		fontWeight: {
			type: String,
			default: 'normal'
		},
		color: {
			type: String
		},
		fontUppercase: {
			type: Boolean,
			default: false
		},
		fontCapitalize: {
			type: Boolean,
			default: false
		},
		tag: {
			type: String,
			default: 'span'
		},
		marginLeft: {
			type: [String, Number]
		},
		marginRight: {
			type: [String, Number]
		}
	},
	name: 'LayoutText',
	data() {
		return {
			boxWhitespace,
			typography,
			textStyle
		}
	},
	computed: {
		classes() {
			const classes = []
			if (this.align) {
				let capAlign = this.align.charAt(0).toUpperCase() + this.align.slice(1)
				classes.push(typography[`align${capAlign}`])
			}
			if (this.fontSize) {
				classes.push(textStyle[`fontSize${this.fontSize}`])
			}
			if (this.fontWeight) {
				let capWeight = this.fontWeight.charAt(0).toUpperCase() + this.fontWeight.slice(1)
				classes.push(typography[`fontWeight${capWeight}`])
			}
			if (this.fontUppercase) {
				classes.push(typography[`fontUppercase`])
			}
			if (this.fontCapitalize) {
				classes.push(typography[`fontCapitalize`])
			}
			return classes
		},
		styles() {
			const styles = []

			if (this.color) {
				styles.push({
					color: this.color
				})
			}

			if (this.marginLeft) {
				styles.push({
					marginLeft: this.marginLeft
				})
			}
			if (this.marginRight) {
				styles.push({
					marginRight: this.marginRight
				})
			}

			return styles
		}
	}
}
</script>
